import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@app/material.module';

import { HeaderComponent } from './header/header.component';
import { SharedModule } from '@app/shared/shared.module';
import { ShellComponent } from './shell.component';
import { ShellSidenavService } from './shell-sidenav.service';
import { ShellLoaderService } from './shell-loader.service';
import { ChatWindowComponent } from '@app/shared/chat/chat-window.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MaterialModule,
        SharedModule,
        RouterModule,
        HeaderComponent,
        ShellComponent,
        ChatWindowComponent
    ],
    providers: [
        ShellSidenavService,
        ShellLoaderService,
    ]
})
export class ShellModule {
  static forRoot(): ModuleWithProviders<ShellModule> {
    return {
      ngModule: ShellModule,
      providers: [
        ShellSidenavService,
        ShellLoaderService,
      ]
    };
  }
}
